import { render } from "./Back.vue?vue&type=template&id=40c05782&scoped=true&ts=true"
import script from "./Back.vue?vue&type=script&lang=ts"
export * from "./Back.vue?vue&type=script&lang=ts"

import "./Back.vue?vue&type=style&index=0&id=40c05782&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c05782"]])

export default __exports__